import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n";
import { TrendingUp } from "lucide-react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { lang, setLang, t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { to: "/", label: t("nav_home") },
    { to: "/methodology", label: t("nav_method") },
    { to: "/guardian", label: "Bund Guardian", sky: true },
    { to: "/reports", label: t("nav_reports") },
    { to: "/guardian/reports", label: "Trading Room Guardian", sky: true },
    { to: "/pricing", label: t("nav_pricing") },
    { to: "/expert-advisors", label: "Expert Advisor", ea: true },
  ];
  if (user) {
    links.splice(1, 0, { to: "/dashboard", label: t("nav_dashboard") });
    links.push({ to: "/downloads", label: "Download EA" });
  }
  if (user?.role === "admin") links.push({ to: "/admin", label: t("nav_admin") });

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 mr-6 font-heading font-bold text-lg tracking-tight text-white">
          <TrendingUp className="w-5 h-5 text-emerald-400" />
          Bund<span className="text-emerald-400">Strategy</span>
        </Link>
        <nav className="hidden md:flex items-center gap-6">
          <a href="https://www.bundstrategy.com" data-testid="nav-link-mainsite"
            className="text-sm text-slate-400 hover:text-white transition-colors">
            {t("nav_mainsite")}
          </a>
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-link-${l.to.replace(/\//g, "-").replace(/^-/, "") || "home"}`}
              className={`text-sm transition-colors ${location.pathname === l.to ? (l.sky ? "text-sky-400" : "text-white") : (l.sky ? "text-sky-400/70 hover:text-sky-300" : "text-slate-400 hover:text-white")}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="lang-toggle" onClick={() => setLang(lang === "it" ? "en" : "it")}
            className="text-xs font-mono uppercase tracking-widest text-slate-400 hover:text-white border border-white/10 rounded px-2 py-1 transition-colors">
            {lang === "it" ? "EN" : "IT"}
          </button>
          {user ? (
            <button data-testid="nav-logout-btn" onClick={async () => { await logout(); navigate("/"); }}
              className="text-sm text-slate-300 hover:text-white border border-white/15 rounded px-3 py-1.5 transition-colors">
              {t("nav_logout")}
            </button>
          ) : (
            <Link to="/login" data-testid="nav-login-btn"
              className="text-sm font-medium bg-emerald-500 hover:bg-emerald-400 text-black rounded px-4 py-1.5 transition-colors">
              {t("nav_login")}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <p data-testid="legal-disclaimer" className="text-xs text-slate-500 leading-relaxed max-w-3xl">{t("disclaimer")}</p>
        <p className="text-xs text-slate-600 mt-3 font-mono">© 2008 BundStrategy · bundstrategy.com</p>
      </div>
    </footer>
  );
};
